<div fxLayout="row" fxLayoutAlign="start center" >
  <span fxFlex [matTooltip]="title" [matTooltipPosition]="'left'" [matTooltipDisabled]="title.length < 60">{{title | truncate: 60}}</span>
  <mat-chip disabled class="library-chip">{{label}}</mat-chip>
  <ng-content></ng-content>
</div>
